export default {
	SET_PENDING_ORDER: "SET_PENDING_ORDER",
	TOGGLE_SHOW_PENDING_RECEIPT: "TOGGLE_SHOW_PENDING_RECEIPT",
	TOGGLE_SHOW_TERMS_AND_CONDITIONS: "TOGGLE_SHOW_TERMS_AND_CONDITIONS",
	TOGGLE_SHOW_INFO_PAGE: "TOGGLE_SHOW_INFO_PAGE",
	INCREMENT_APP_OPENED_COUNTER: "INCREMENT_APP_OPENED_COUNTER",
	INCREMENT_PURCHASE_COUNTER: "INCREMENT_PURCHASE_COUNTER",
	INCREMENT_NOTIFICATIONS_DIALOG_COUNTER: "INCREMENT_NOTIFICATIONS_DIALOG_COUNTER",
	SET_NATIVE_PERMISSIONS_DIALOG_SHOWN: "SET_NATIVE_PERMISSIONS_DIALOG_SHOWN",
	SET_USER_IDP_TOKEN: "SET_USER_IDP_TOKEN",
	REMOVE_USER_IDP_TOKEN: "REMOVE_USER_IDP_TOKEN",
	SET_GIGYA_TOKEN: "SET_GIGYA_TOKEN",
	REMOVE_GIGYA_TOKEN: "REMOVE_GIGYA_TOKEN",
	SET_CJR_TRACKING_ID: "SET_CJR_TRACKING_ID",
	SET_USER_EMAIL: "SET_USER_EMAIL",
	SET_OFFER_IDS: "SET_OFFER_IDS",
	REMOVE_OFFER_IDS: "REMOVE_OFFER_IDS",
	RESET_LOYALTY_DATA: "RESET_LOYALTY_DATA",
	FETCH_LOYALTY_OFFERS: "FETCH_LOYALTY_OFFERS",
	SET_LOYALTY_LOADING: "SET_LOYALTY_LOADING",
	SET_LOYALTY_ERROR: "SET_LOYALTY_ERROR",
	GET_LOYALTY_OFFERS: "GET_LOYALTY_OFFERS"
};
